import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import CumStats from "./Components/CumStats";
import TradeHistory from "./Components/TradeHistory";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";

export default function TradeDetail() {
  const navigate = useNavigate();
  const { accountId: accountCode } = useParams();
  const [accLoading, setAccLoading] = useState(true);
  const [accountData, setAccountData] = useState({
    details: null,
    trades: [],
    accountCode,
  });

  useEffect(() => {
    if (!accountCode) return;

    let isCancelled = false;

    const fetchWithRefresh = async (url) => {
      let response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return null;
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        });
      }

      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      return response.json();
    };

    const fetchAccountData = async () => {
      setAccLoading(true);

      try {
        const [detailsResponse, tradeHistoryResponse] = await Promise.all([
          fetchWithRefresh(
            `${API_BASE_URL}trading/accounts/${accountCode}/details`,
          ),
          fetchWithRefresh(
            `${API_BASE_URL}trading/accounts/${accountCode}/trade-history`,
          ),
        ]);

        if (isCancelled) return;

        setAccountData({
          details: detailsResponse?.details ?? detailsResponse ?? null,
          trades: Array.isArray(tradeHistoryResponse?.trades)
            ? tradeHistoryResponse.trades
            : null,
          accountCode,
        });
      } catch (error) {
        if (!isCancelled) {
          console.error("Error fetching account data:", error);
          setAccountData({
            details: null,
            trades: [],
            accountCode,
          });
        }
      } finally {
        if (!isCancelled) {
          setAccLoading(false);
        }
      }
    };

    fetchAccountData();

    return () => {
      isCancelled = true;
    };
  }, [accountCode, navigate]);

  return (
    <LayoutPage
      activeIndex={3}
      navItems={["حساب‌ها و چالش‌ها", `حساب ${accountCode}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["حساب در یک نگاه", "جزئیات معاملات"]}
        hrefs={[
          `/challenge/account/${accountCode}/overview`,
          `/challenge/account/${accountCode}/trade-detail`,
        ]}
        activeIndex={1}
      />
      <div className="w-full h-fit flex flex-col gap-5 min-h-0 overflow-y-auto">
        <CumStats accountData={accountData} accLoading={accLoading} />
        <TradeHistory accountData={accountData} accLoading={accLoading} />
      </div>
    </LayoutPage>
  );
}
